import { render, staticRenderFns } from "./SidebarCompanySelect.vue?vue&type=template&id=5dc0e80d&scoped=true"
import script from "./SidebarCompanySelect.vue?vue&type=script&lang=js"
export * from "./SidebarCompanySelect.vue?vue&type=script&lang=js"
import style0 from "./SidebarCompanySelect.vue?vue&type=style&index=0&id=5dc0e80d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc0e80d",
  null
  
)

export default component.exports